import { formatPhoneNumber } from '../../../utils/numbers'
import Text from './Text'

const formatNumber = (countryCode, name) => text => {
  const len = text ? text.toString().length : 0
  if (len === 0) return ''
  if (document.activeElement.name === name && document.activeElement.value) {
    return text
  }
  return formatPhoneNumber(text, countryCode)
}

export default props => {
  const { countryCode, shouldFormat, name } = props
  const newProps = {
    ...props,
    format: shouldFormat && countryCode ? formatNumber(countryCode, name) : null,
  }
  return <Text {...newProps} />
}
